﻿import { KbCheckbox } from "@app/components/kb-checkbox/kb-checkbox.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";

interface IToggleScope extends ng.IScope {
    ngModel?: any;
    ngDisabled?: boolean;
    inputId?: string;
    ngChange?: () => void;
    _ngChange: () => void;
}

@NgComponent({
    token: Token.KbToggle,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbToggle extends KbCheckbox {
    constructor($timeout: ng.ITimeoutService) {
        super($timeout);
       
        this.template = Dirs.component("kb-toggle");
    }
}
